import { render, staticRenderFns } from "./EbaAggregatedResultsTable.vue?vue&type=template&id=586bb44a&scoped=true&"
import script from "./EbaAggregatedResultsTable.vue?vue&type=script&lang=ts&"
export * from "./EbaAggregatedResultsTable.vue?vue&type=script&lang=ts&"
import style0 from "./EbaAggregatedResultsTable.vue?vue&type=style&index=0&id=586bb44a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586bb44a",
  null
  
)

export default component.exports